import { useState, useEffect } from 'react';

export interface AppStoreDetails {
  trackId: string;
  bundleId: string;
  trackName: string;
  version: string;
  description: string;
  artworkUrl100: string;
  primaryGenreName: string;
}

export const useAppStoreDetails = (trackId: string) => {
  const [appDetails, setAppDetails] = useState<AppStoreDetails | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAppDetails = async () => {
      if (!trackId) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        console.log('useAppStoreDetails - Fetching details for trackId:', trackId);
        
        const response = await fetch(`https://itunes.apple.com/lookup?id=${trackId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch app details');
        }
        
        const data = await response.json();
        if (data.results && data.results.length > 0) {
          setAppDetails(data.results[0]);
          console.log('useAppStoreDetails - App details loaded:', data.results[0]);
        } else {
          throw new Error('App not found');
        }
      } catch (error) {
        console.error('Error fetching app details:', error);
        setError(error instanceof Error ? error.message : 'Failed to fetch app details');
        setAppDetails(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAppDetails();
  }, [trackId]);

  return {
    appDetails,
    isLoading,
    error
  };
};